/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/418-vimeo2': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M14.5 0h-13C.675 0 0 .675 0 1.5v13c0 .825.675 1.5 1.5 1.5h13c.825 0 1.5-.675 1.5-1.5v-13c0-.825-.675-1.5-1.5-1.5zm-1.037 5.313c-.05 1.125-.838 2.666-2.359 4.622-1.572 2.044-2.903 3.066-3.991 3.066-.675 0-1.244-.622-1.709-1.866-.313-1.141-.622-2.281-.934-3.422-.344-1.244-.716-1.866-1.112-1.866-.087 0-.391.181-.906.544l-.544-.7c.572-.5 1.134-1.003 1.687-1.503.763-.656 1.331-1.003 1.712-1.038.9-.087 1.453.528 1.662 1.844.225 1.422.381 2.303.469 2.65.259 1.178.544 1.766.856 1.766.241 0 .606-.381 1.091-1.147s.744-1.347.778-1.747c.069-.659-.191-.991-.778-.991-.278 0-.563.063-.856.191.569-1.859 1.653-2.766 3.256-2.712 1.188.034 1.747.803 1.678 2.309z"/>'
  }
})
